// PartnerContext.tsx
import { createContext, useContext, useState, useEffect } from "react";
import { useGetCategoryPartnerActive } from "#/requests/get-category-partner-active";
import { ContentItem } from "#/api/partnersShowcase/partnersShowcase";

type typePartner = "SISTEMICO" | "LOCAL";

interface ICategoryPartnerLocalContext {
  categoryPartnersLocal: any;
  setCurrentPage: (page: number) => void;
  currentPage: number;
  setPartnerType: (typePartner: typePartner) => void;
  partnerType: typePartner;
  uf: string;
  setUf: (uf: string) => void;
  size: number;
  setSize: (size: number) => void;
  city: string;
  setCity: (city: string) => void;
}

const CategoryPartnerLocalContext = createContext<ICategoryPartnerLocalContext>(
  {} as ICategoryPartnerLocalContext
);

export const CategoryPartnerLocalProvider = ({ children }: any) => {
  const [categoryPartnersLocal, setCategoryPartnerLocal] = useState<
    ContentItem[] | undefined
  >([]);
  const [uf, setUf] = useState("");
  const [city, setCity] = useState("");
  const [size, setSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [partnerType, setPartnerType] = useState("" as typePartner);
  const activeCategory = useGetCategoryPartnerActive({
    typePartner: "LOCAL",
    page: currentPage - 1,
    uf: uf || undefined,
    city: city || undefined,
    size: size,
  });

  useEffect(() => {
    if (activeCategory.data) {
      setCategoryPartnerLocal(activeCategory?.data?.content);
    }
  }, [activeCategory.data, city]);

  return (
    <CategoryPartnerLocalContext.Provider
      value={{
        categoryPartnersLocal,
        setCurrentPage,
        currentPage,
        setPartnerType,
        partnerType,
        uf,
        setUf,
        city,
        setCity,
        size,
        setSize,
      }}
    >
      {children}
    </CategoryPartnerLocalContext.Provider>
  );
};

export const useCategoryPartnerLocalContext = () =>
  useContext(CategoryPartnerLocalContext);
